export default __webpack_public_path__ + "buysearchsell/images/single-promo-section-background.jpg";